export const messages = {
  en: {
    userDetailVip: {
      shop: 'Shop',
      vipId: 'VIP ID',
      vipName: 'VIP Name',
      vipTel: 'VIP Phone',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      vipLevel: 'VIP Level',
      vipBirthday: 'VIP Birthday',
      startTime: 'Start Time',
      endTime: 'End Time'
    }
  },
  zh: {
    userDetailVip: {
      shop: '店铺',
      vipId: '会员编号',
      vipName: '会员名称',
      vipTel: '会员电话',
      gender: '性别',
      male: '男',
      female: '女',
      vipLevel: '会员等级',
      vipBirthday: '会员生日',
      startTime: '开始时间',
      endTime: '结束时间'
    }
  }
}